import { createContext, RefObject } from 'react';

import { Instance, Instances } from '@spazious/dollhouse-three';

export type ModelContextValue = {
  getParent: (url: string) => Instances | null;
  subscribe: (url: string, ref: RefObject<Instance>) => (() => void) | void;
};

export const ModelContext = createContext<ModelContextValue | null>(null);
